module.exports = __webpack_public_path__ + "img/Arrow_right_wh.1af5fce7.svg";